module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.8ff9b573.ttf";